// extracted by mini-css-extract-plugin
export default {"HeaderLeft":"style_HeaderLeft__6qqqh","HeaderRight":"style_HeaderRight__Q4D8Q"};